import { Routes, Route } from "react-router-dom";
import "./app.css";
import Navbar from "./components/Navbar";

// Import your route components
import Home from "./routes/home";
import Login from "./routes/login";
import Register from "./routes/register";
import MentorsList from "./scenes/mentorship/MentorsList";
import MentorshipSessionCreate from "./scenes/mentorship/MentorshipSessionCreate";
import UserProfileView from "./scenes/userprofile/UserProfileView";
import ScholarshipsView from "./scenes/scholarship/ScholarshipsView";
import { useEffect } from "react";
import ScholarshipDetailView from "./scenes/scholarship/ScholarshipDetailView";

export default function App() {

    useEffect(() => {
    console.log('App useEffect');
  }, []); // Empty dependency array ensures this runs only once on mount

  return (
    <>
      <Navbar />
      <div className="pt-16"> {/* Add padding to account for fixed navbar */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/profile/:username" element={<UserProfileView />} />
          <Route path="/mentorship" element={<MentorsList />} />
          <Route path="/mentorship/session/new/:mentorUsername" element={<MentorshipSessionCreate />} />
          <Route path="/m/:mentorUsername" element={<MentorshipSessionCreate />} />
          <Route path="/scholarship" element={<ScholarshipsView />} />
          <Route path="/scholarship/:scholarshipSlug" element={<ScholarshipDetailView />} />
        </Routes>
      </div>
    </>
  );
}
